import React from "react";

import PropTypes from "prop-types";
import styled from "styled-components/macro";

import LogoIcon from "img/AgriNous-icon";

const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
  margin: auto ${({ theme }) => theme.space[1]}px;
`;

const AgriNousActiveLogoComponent = ({ isActive }) => {
  return (
    <IconWrapper backgroundColor={isActive ? "successGreen" : "grayDisabled"}>
      <LogoIcon
        color={isActive ? "white" : "gray9C"}
        envColor={isActive ? "white" : "gray9C"}
        scale={0.7}
      />
    </IconWrapper>
  );
};

AgriNousActiveLogoComponent.propTypes = {
  isActive: PropTypes.bool,
};

const AgriNousActiveLogo = React.memo(AgriNousActiveLogoComponent);

export default AgriNousActiveLogo;
